export default {
    title: 'Video Avatars',
    shelfEmpty: 'No one with a video avatar is online right now',
    shelfError: "Video avatars couldn't load",
    retry: 'Try again',
    watch: "Watch {{username}}'s video avatar",
    preview: 'Preview',
    preRecorded: 'Pre-recorded clip',
    status: {
        live: 'Live',
        watching: '{{viewers}} watching',
        club: 'Club show',
        group: 'Group show',
        private: 'In private',
        away: 'Away',
        offline: 'Offline',
    },
    goToRoom: 'Go to her room',
    viewProfile: 'View profile',
    swipeHint: 'Swipe up for next',
    friend: 'Friend',
    friended: 'Friended',
    bookmark: 'Bookmark',
    bookmarked: 'Bookmarked',
    mute: 'Mute',
    unmute: 'Unmute',
    play: 'Play',
    soundOn: 'Sound on',
    more: 'More',
    openMenu: "Open {{username}}'s menu",
    close: 'Close',
    previous: 'Previous model',
    next: 'Next model',
    keyUp: '↑',
    keyDown: '↓',
    keySpace: 'Space',
    keyEscape: 'Esc',
    keysMove: 'to move',
    keysPause: 'to pause',
    keysClose: 'to close',
    endTitle: "You've seen everyone with a video avatar right now",
    endBody: 'New ones show up here as models with a video avatar come online.',
    browseLive: 'Browse live models',
    startOver: 'Start over',
}
